<div class="monitoring-card rounded" *ngIf="monitor && !monitor.error">
  <div class="center container-fluid p-0">
    <div class="row center p-0 m-0">
      <div class="col-lg-6 col-12 p-0 m-0 center rounded-left">
        <div class="container leftCol">
          <div class="row dataRow">
            <div class="col-2 center">
              <img class="logo" src="../../../assets/icon/three-buildings.svg" alt="">
            </div>
            <div class="col-10">
              <div class="container">
                <div class="row">
                  <span class="title">{{monitor.devicePtr.companyIdentifier}}</span>
                </div>
                <div class="row">
                  {{ monitor.devicePtr.id }}
                </div>
              </div>
            </div>
          </div>
          <div class="row dataRow">
            <div class="col-2 center">
              <img class="logo" src="../../../assets/icon/server.svg" alt="">
            </div>
            <div class="col-10">
              <div class="container">
                <div class="row">
                  <span class="title" i18n="monitoring|@@localIp">IP Local</span>
                </div>
                <div class="row">
                  {{ monitor.devicePtr.ipMachine}}
                </div>
              </div>
            </div>
          </div>
          <div class="row dataRow">
            <div class="col-2 center">
              <img class="logo" src="../../../assets/icon/synchronization-arrows.svg" alt="">
            </div>
            <div class="col-10">
              <div class="container">
                <div class="row">
                  <span class="title" i18n="exportKpi|@@lastConnexion">Dernière connexion</span>
                </div>
                <div class="row">
                  {{ monitor?.devicePtr?.dateMonitoring | date:'short':'':'fr'}}
                </div>
              </div>
            </div>
          </div>
          <div class="row dataRow">
            <div class="col-2 center">
              <img class="logo" src="../../../assets/icon/pin.svg" alt="">
            </div>
            <div class="col-10">
              <div class="container">
                <div class="row">
                  <span class="title">{{ monitor.devicePtr.address }}</span>
                </div>
                <div class="row">
                  {{ monitor.devicePtr.gpsLocation }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-12  p-0 m-0 center">
        <div class="container">
          <div class="row">
            <div class="col-4">
              <img src="../../../assets/icon/settings.svg" alt="">
            </div>
            <div class="col-8 mt-2">
              <img src="../../../assets/icon/thermometer.svg" alt="">
              <span class="title">M {{ monitor?.masterTemp}}°</span>
            </div>
          </div>
          <div class="row">
            <div class="col-4">
            </div>
            <div class="col-8 mt-2">
              <img src="../../../assets/icon/thermometer.svg" alt="">
              <span class="title">S {{ monitor?.slaveTemp}}°</span>
            </div>
          </div>
          <div class="row">
            <div class="col-12 p-4 ">
              <div class="logoCenter" *ngIf="monitor.critical === undefined ;else criticalTemplate">
                <img [ngClass]="{'d-none': logo === true}" class="logoTchek"
                  src='../../../assets/icon/tchek-pastille.svg' alt="">
                <img [ngClass]="{'d-none': logo === false}" class="logoTchek" src='../../../assets/icon/tchek-blue.svg'
                  alt="">
              </div>
            </div>
            <ng-template #criticalTemplate>
              <div class="criticalMessage" *ngFor="let message of monitor.critical">
                {{message}}
              </div>
            </ng-template>
          </div>
          <div class="row">
            <div class="col-lg-6 col-12 p-0 m-0">
              <div class="container p-0 m-0">
                <div class="row p-0 m-0">
                  <div class="col-12 inline">
                    <span class="small"><img src="../../../assets/icon/debian.svg" alt=""></span>
                    <span class="boxVersion absolute">{{ monitor?.os}}</span>
                  </div>
                </div>
                <div class="row p-0 m-0">
                  <div class="col-12 inline">
                    <span class="small"><img src="../../../assets/icon/angular.svg" alt=""> Front</span>
                    <span class="boxVersion absolute">{{ monitor?.front}}</span>
                  </div>
                </div>
                <div class="row p-0 m-0">
                  <div class="col-12">
                    <span class="small"><img src="../../../assets/icon/nodejs.svg" alt=""> Back</span>
                    <span class="boxVersion absolute">{{ monitor?.back}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-12  pr-1 pb-1 pl-0  m-0">
              <div class="container p-0 m-0">
                <div class="row p-0 m-0">
                  <div class="col-12 p-0 m-0 inline">
                    <span class="small">UCTchek M.</span>
                    <span class="boxVersion" [ngClass]="{'absolute': monitor.ucm.length < 14}">{{ monitor?.ucm }}</span>
                  </div>
                </div>
                <div class="row p-0 m-0">
                  <div class="col-12 p-0 m-0 inline">
                    <span class="small">UCTchek S.</span>
                    <span class="boxVersion" [ngClass]="{'absolute': monitor.ucs.length < 14}">{{ monitor?.ucs }}</span>
                  </div>
                </div>
                <div class="row p-0 m-0">
                  <div class="col-12 p-0 m-0 inline">
                    <span class="small">KittIA</span>
                    <span class="boxVersion absolute">{{ monitor?.kittIa }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="monitoring-card rounded" *ngIf="monitor === undefined && device">
  <div class="center container">
    <div class="center row p-5">
      <div class="center col-12">
        <strong>ERROR :</strong>
      </div>
      <div class="center col-12">
        <span i18n="monitoringCard|@@MonitorDoesntExist">La table MonitorStatus n'existe pas pour le device </span> <strong>{{device.id}}</strong>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/element/monitoring-card/monitoring-card.component.html